import { render, staticRenderFns } from "./RelatorioDashboard.vue?vue&type=template&id=528a79e6"
import script from "./RelatorioDashboard.vue?vue&type=script&lang=js"
export * from "./RelatorioDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports